<script>
import PageHeader from "@/components/page-header";

export default {
  data() {
    return {
      title: "Staff List",
    };
  },
  components: {
    PageHeader,
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead class="table-light">
                <tr>
                  <th>staff name</th>
                  <th>staff#</th>
                  <th>Department</th>
                  <th>Mobile</th>
                  <th>email</th>
                  <th>mobile key</th>
                  <th>status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="position-relative">
                        <span
                          class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-primary rounded-circle picture-img"
                        >
                          A
                        </span>
                      </div>
                      <div class="word-break-text">
                        <span class="ms-2"> akshay thummar</span>
                      </div>
                    </div>
                  </td>
                  <td>xxxxxxxx</td>
                  <td>Frontdesk</td>
                  <td>8980204222</td>
                  <td>akshaythummar109@gmail.com</td>
                  <td>Yes</td>
                  <td>Active</td>
                  <td>
                    <div slot="actions" class="d-flex align-items-center">
                      <i class="fas fa-pencil-alt text-success fs-5"></i>
                      <i class="mdi mdi-trash-can ms-3 text-danger fs-4"></i>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="position-relative">
                        <span
                          class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-primary rounded-circle picture-img"
                        >
                          A
                        </span>
                      </div>
                      <div class="word-break-text">
                        <span class="ms-2"> akshay thummar</span>
                      </div>
                    </div>
                  </td>
                  <td>xxxxxxxx</td>
                  <td>Frontdesk</td>
                  <td>8980204222</td>
                  <td>akshaythummar109@gmail.com</td>
                  <td>Yes</td>
                  <td>Active</td>
                  <td>
                    <div slot="actions" class="d-flex align-items-center">
                      <i class="fas fa-pencil-alt text-success fs-5"></i>
                      <i class="mdi mdi-trash-can ms-3 text-danger fs-4"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
